import { HOST, } from "common/constants";
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, A11y, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

import classes from "./hero.module.scss";
import logo from "assets/images/logo_footer.png";

import axios from "axios";
import { useTranslation } from "react-i18next";

const Hero = () => {
  const [slides, setSlides] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    axios
      .get(`${HOST}/api/v1/hero-image/`)
      .then((res) => {
        const results = res.data.results?.[0]?.images || [];
        setSlides(results);
      })
      .catch((err) => {
        console.error("Ошибка при загрузке слайдов:", err);
      });
  }, []);

  return (
    <Swiper
      modules={[Pagination, A11y, Autoplay]}
      pagination={{ clickable: true }}
      loop
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      style={{ width: "100%", height: "500px" }}
    >
      {slides.map((slide, idx) => (
        <SwiperSlide key={idx}>
          <SwiperSlide key={idx}>
            <Box
              className={classes.hero}
              sx={{
                backgroundImage: `url(${slide.image})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
                height: "500px",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
              }}
            >
              <Box className={classes.overlay} />
              <Box className={classes.box}>
                <Typography className={classes.caption}>
                  {t("union")}
                </Typography>
                <Box className={classes.heroContent}>
                   <img style={{height:"140px"}} src={logo} alt="logo" />
                </Box>
              </Box>
            </Box>
          </SwiperSlide>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Hero;
